// src/features/store/services/storeService.ts

import api from '../../../api/axios';

import {
  STORE_ENDPOINTS,
} from '../../../api';

import type {
  ApiResponse,
} from '../../../shared/types/api.types';

import type {
  CreateStoreRequest,
  StoreListItem,
  UpdateStoreRequest,
} from '../types/store.types';

export const storeService = {
  /**
   * 전체 매장 목록 조회
   *
   * storeId = 0은
   * 라포이트 포인트용 가상 지점이므로 제외
   */
  async getStores():
    Promise<StoreListItem[]> {
    const response =
      await api.get<
        ApiResponse<StoreListItem[]>
      >(
        STORE_ENDPOINTS.LIST,
      );

    return response.data.data.filter(
      (store) =>
        store.storeId !== 0,
    );
  },

  /**
   * 매장 상세 조회
   */
  async getStoreById(
    storeId: number,
  ): Promise<StoreListItem> {
    const response =
      await api.get<
        ApiResponse<StoreListItem>
      >(
        STORE_ENDPOINTS.DETAIL(
          storeId,
        ),
      );

    return response.data.data;
  },

  /**
   * 매장 이름만 조회
   */
  async getStoreNameById(
    storeId: number,
  ): Promise<string> {
    const store =
      await this.getStoreById(
        storeId,
      );

    return store.storeName;
  },

  /**
   * 지점 생성
   *
   * SUPERADMIN
   */
  async createStore(
    data: CreateStoreRequest,
  ): Promise<StoreListItem> {
    const response =
      await api.post<
        ApiResponse<StoreListItem>
      >(
        STORE_ENDPOINTS
          .SUPERADMIN
          .CREATE,
        data,
      );

    return response.data.data;
  },

  /**
   * 지점 수정
   *
   * SUPERADMIN
   */
  async updateStore(
    storeId: number,
    data: UpdateStoreRequest,
  ): Promise<StoreListItem> {
    const response =
      await api.put<
        ApiResponse<StoreListItem>
      >(
        STORE_ENDPOINTS
          .SUPERADMIN
          .DETAIL(
            storeId,
          ),
        data,
      );

    return response.data.data;
  },

  /**
   * 지점 삭제
   *
   * SUPERADMIN
   */
  async deleteStore(
    storeId: number,
  ): Promise<void> {
    await api.delete(
      STORE_ENDPOINTS
        .SUPERADMIN
        .DETAIL(
          storeId,
        ),
    );
  },

  /**
   * 지점 포인트 발행
   *
   * ADMIN / SUPERADMIN
   */
  async mintStorePoints(
    storeId: number,
    amount: number,
  ): Promise<void> {
    await api.patch(
      STORE_ENDPOINTS
        .ADMIN
        .MINT_POINTS(
          storeId,
        ),
      null,
      {
        params: {
          amount,
        },
      },
    );
  },
};